"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItem = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".c5b476df7{border-radius:.625rem;background:#fff;padding:.75rem 1.5625rem;margin-bottom:1.25rem;color:#4f4f4f;-webkit-user-select:none;-ms-user-select:none;user-select:none;transition:box-shadow var(--animation-timing-def) ease;cursor:pointer;font-size:1rem;font-weight:400;line-height:1.5rem}.c5b476df7:last-child{margin-bottom:0}.c5b476df7:hover{box-shadow:0 .1875rem .3125rem rgba(0,0,0,.1);-webkit-transform:translateY(-.0625rem);transform:translateY(-.0625rem)}.c1218e851{color:var(--color-flomni-blue-70);box-shadow:0 .1875rem .3125rem rgba(0,0,0,.1)}.c1218e851:hover{box-shadow:0 .1875rem .3125rem rgba(0,0,0,.1);-webkit-transform:none;transform:none}.c9f5df27b{color:rgba(79,79,79,.3);cursor:default;box-shadow:none}.c9f5df27b:hover{box-shadow:none;-webkit-transform:none;transform:none}");
var styles = {
  root: 'c5b476df7',
  '--selected': 'c1218e851',
  '--disabled': 'c9f5df27b'
};

var MenuItem = function MenuItem(props) {
  var onClick = props.onClick,
      children = props.children,
      selected = props.selected,
      classes = props.classes,
      disabled = props.disabled;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  var onClickHandler = (0, _react.useCallback)(function () {
    if (disabled) return;
    onClick.apply(void 0, arguments);
  }, [disabled, onClick]);
  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: onClickHandler,
    className: (0, _classnames.default)(cn.root, (0, _defineProperty2.default)({}, cn.selected, selected), (0, _defineProperty2.default)({}, cn.disabled, disabled))
  }, children);
};

exports.MenuItem = MenuItem;
MenuItem.propTypes = {
  /* component logic props */
  onClick: _propTypes.func.isRequired,
  children: _propTypes.node.isRequired,
  selected: _propTypes.bool,
  disabled: _propTypes.bool,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
MenuItem.defaultProps = {
  selected: false,
  disabled: false,
  classes: {}
};